/* eslint-disable @typescript-eslint/ban-ts-ignore */
import EnergyMeter from "../components/ncsc/EnergyMeter";
import ScoreTimer from "../components/ncsc/ScoreTimer";
import ResultsComponent from "../components/ncsc/ResultsComponent";

import BaseScene from "./BaseScene";

//assets

import AvatarSpriteTexture from "../../assets/atlas/avatarWalkCycles.png";
import AvatarSpriteData from "../../assets/atlas/avatarWalkCycles.json";

import EnemySpriteTexture from "../../assets/atlas/enemyWalkCycles.png";
import EnemySpriteData from "../../assets/atlas/enemyWalkCycles.json";

import padlockTexture from "../../assets/atlas/padlock-spritesheet.png";
import pickupTexture from "../../assets/atlas/powerup-spritesheet.png";

import { shuffleArrayFY } from "../plugins/utils/Utils";
import { PostPipeline } from "../plugins/global/PostEffectPlugin";

import jumpButton from "../../assets/img/jumpButton.png";

//sounds
import EndGameSound from "../../assets/audio/Designed Circuits - Noise burst, short, servo (2).ogg";
import NegativeHitSound from "../../assets/audio/BB_DRL__086.ogg";
import NegativeFlickerHitSound from "../../assets/audio/CK_Sensors-13.ogg";
import PosativePowerupSound from "../../assets/audio/CK_Blaster_Shot-226.ogg";
import GenericCollectionSound from "../../assets/audio/Computation_Light_20.ogg";
import GenericCollectionSound2 from "../../assets/audio/Simple_Tone_43.ogg";
import AddScoreSound from "../../assets/audio/Telemetry_13.ogg";
import TransitionSound from "../../assets/audio/SciFi_Transition_11.ogg";
import MusicSound from "../../assets/audio/Ludum Dare 38 - Track 4.ogg";
import MusicSoundAlt from "../../assets/audio/Ludum Dare 38 - Track 4 v2 sparse drums.ogg";
import SmallPickupSound from "../../assets/audio/click.ogg";

//sounds mp3
import EndGameSoundMP3 from "../../assets/audio/Designed Circuits - Noise burst, short, servo (2).mp3";
import NegativeHitSoundMP3 from "../../assets/audio/BB_DRL__086.mp3";
import NegativeFlickerHitSoundMP3 from "../../assets/audio/CK_Sensors-13.mp3";
import PosativePowerupSoundMP3 from "../../assets/audio/CK_Blaster_Shot-226.mp3";
import GenericCollectionSoundMP3 from "../../assets/audio/Computation_Light_20.mp3";
import GenericCollectionSound2MP3 from "../../assets/audio/Simple_Tone_43.mp3";
import AddScoreSoundMP3 from "../../assets/audio/Telemetry_13.mp3";
import TransitionSoundMP3 from "../../assets/audio/SciFi_Transition_11.mp3";
import MusicSoundMP3 from "../../assets/audio/Ludum Dare 38 - Track 4.mp3";
import MusicSoundAltMP3 from "../../assets/audio/Ludum Dare 38 - Track 4 v2 sparse drums.mp3";
import SmallPickupSoundMP3 from "../../assets/audio/click.mp3";

import CountDown from "../components/ncsc/CountDown";
import FullScreenQuestionComponent from "../components/ncsc/FullScreenQuestionComponent";
import { QuestionModel } from "../interfaces/IContentModel";
import PauseScreen from "../components/ncsc/PauseScreen";
import QuestionPopupComponent from "../components/ncsc/QuestionPopupComponent";

/**
 * represents a lane for the endless runner
 *
 * @export
 * @enum {number}
 */
export enum Lane {
  LEFT = 0,
  CENTER = 1,
  RIGHT = 2,
}

/**
 * display list draw depths.
 *
 * @export
 * @enum {number}
 */
export enum Depths {
  BACKGROUND = 0,
  LEVEL,
  COLLECTABLES,
  AVATAR,
  UI,
}

export interface GameSounds {
  EndGameSound?: Phaser.Sound.BaseSound;
  NegativeHitSound?: Phaser.Sound.BaseSound;
  NegativeFlickerHitSound?: Phaser.Sound.BaseSound;
  PosativePowerupSound?: Phaser.Sound.BaseSound;
  GenericCollectionSound?: Phaser.Sound.BaseSound;
  GenericCollectionSound2?: Phaser.Sound.BaseSound;
  AddScoreSound?: Phaser.Sound.BaseSound;
  TransitionSound?: Phaser.Sound.BaseSound;
  smallPickup?: Phaser.Sound.BaseSound;

  music?: Phaser.Sound.WebAudioSound;
  musicAlt?: Phaser.Sound.WebAudioSound;
}

/**
 * Lane position in pixels, start & end are for perspective.
 *
 * @export
 * @const {number[]}
 */
export const lanePositions: number[] = [100, 360, 620];
export const lanePositionsStart: number[] = [300, 360, 420];
export const lanePositionsEnd: number[] = [50, 360, 670];

export const lanePositionsStartBounds: { min: number; max: number } = {
  min: 300,
  max: 420,
};
export const lanePositionsEndBounds: { min: number; max: number } = {
  min: 50,
  max: 670,
};

/**
 *
 * @category scenes
 * @export
 * @class EndlessRunnerScene
 * @extends {BaseScene}
 */
export default class EndlessRunnerScene extends BaseScene {
  created: boolean = false;

  /**
   * is the runner paused (mini-game is active)
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */
  paused: boolean = false;

  /**
   * is the pause screen visible?
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */
  pauseScreenVisible: boolean = false;

  /**
   * is the padlock question screen visible?
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */
  padlockQuestionVisible: boolean = false;

  currentPadlockQuestion: FullScreenQuestionComponent;

  /**
   * is a minigame active and visible?
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */
  miniGameActive: boolean = false;

  /**
   * has the game ended
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */

  /**
   * is player jumping
   *
   * @type {boolean}
   * @memberof EndlessRunnerScene
   */
  jumpingActive: boolean = false;
  ended: boolean = false;

  bg: Phaser.GameObjects.Image;

  //groups for game objects
  /**
   * things to collect that give you energy
   *
   * @type {Phaser.GameObjects.Group}
   * @memberof EndlessRunnerScene
   */
  collecatables: Phaser.GameObjects.Group;
  /**
   * things to collect that give you energy
   *
   * @type {Phaser.GameObjects.Group}
   * @memberof EndlessRunnerScene
   */
  singlePoints: Phaser.GameObjects.Group;

  /**
   * things you collect that take energy away
   *
   * @type {Phaser.GameObjects.Group}
   * @memberof EndlessRunnerScene
   */
  avoidables: Phaser.GameObjects.Group;

  /**
   * items that launch mini games
   *
   * @type {Phaser.GameObjects.Group}
   * @memberof EndlessRunnerScene
   */
  miniGameLaunchers: Phaser.GameObjects.Group;

  //custom lines for perspective drawing
  horizontalLines: Phaser.GameObjects.Group;

  /**
   * main runner character
   *
   * @type {Phaser.GameObjects.Sprite}
   * @memberof EndlessRunnerScene
   */
  avatar: Phaser.GameObjects.Sprite;

  /**
   * used to flip WebGL pipline as there is an issue when combining piplines
   *
   * @private
   * @type {Phaser.GameObjects.Sprite}
   * @memberof EndlessRunnerScene
   */
  private _avatarDisplay: Phaser.GameObjects.Sprite;

  private jumpButton: Phaser.GameObjects.Image;
  /**
   * displays the current energy
   *
   * @type {EnergyMeter}
   * @memberof EndlessRunnerScene
   */
  energyMeter: EnergyMeter;
  /**
   * time / score display
   *
   * @type {ScoreTimer}
   * @memberof EndlessRunnerScene
   */
  timer: ScoreTimer;

  /**
   * results component show at end of game
   *
   * @type {ResultsComponent}
   * @memberof EndlessRunnerScene
   */
  results?: ResultsComponent;

  /**
   * Current Lane
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  avatarPosition: number = Lane.CENTER;
  /**
   * distance traveld
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  currentDistance: number = 0;
  /**
   * distance traveled since last line spawn
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  lastLineDistance: number = 0;
  /**
   * distance traveled since last collectable spawn
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  lastCollectableDistance: number = 0;
  lastPointDistance: number = 0;

  /**
   * how many cycles of distance since a minigame spawn
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  lastMiniGameCount: number = 0;

  /**
   * how many cycles of distance since a energy pickup spawn
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  lastEnergyCount: number = 0;

  /**
   * current runner gameplay speed
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  gameSpeed: number = 0.05;

  /**
   * how many minigames have been launched this run/
   *
   * @type {number}
   * @memberof EndlessRunnerScene
   */
  currentMiniGameCount: number = 0;

  /**
   * minigames that can be launched, these are the keys defined in thier constructor.
   *
   * @type {string[]}
   * @memberof EndlessRunnerScene
   */
  miniGames: string[] = [];

  currentQuestions: QuestionModel[] = [];
  totalQuestionsAsked: number = 0;

  sounds: GameSounds;
  pauseButton: Phaser.GameObjects.Image;
  pauseScreen: PauseScreen;

  effects: boolean;
  countdownDisplay: CountDown;

  goCountdownActive = false;

  constructor() {
    super({
      key: "EndlessRunnerScene",
      active: false, // false means this state isn't loaded on boot. true means its instantly activated.
    });
    console.log("EndlessRunnerScene::constructor");
  }

  /**
   * reset the game and start
   *
   * @memberof EndlessRunnerScene
   */
  restart() {
    console.log("restartGame");
    this.sponge.data.save.seenCorrectFeedback = [];
    //this.totalQuestionsAsked = 0;
    this.energyMeter.reset();
    this.timer.reset();

    this.populatePadlockQuestions();

    this.singlePoints.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        gameObject.setActive(false).setVisible(false);
      }
    );
    this.miniGameLaunchers.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        gameObject.setActive(false).setVisible(false);
      }
    );

    this.avoidables.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        gameObject.setActive(false).setVisible(false);
      }
    );
    this.collecatables.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        gameObject.setActive(false).setVisible(false);
      }
    );

    this.avatarPosition = Lane.CENTER;
    this.currentDistance = 0;
    this.lastLineDistance = 0;
    this.lastCollectableDistance = 0;
    this.lastPointDistance = 0;
    this.lastMiniGameCount = 0;
    this.lastEnergyCount = 0;
    this.gameSpeed = 0.05;
    this.currentMiniGameCount = 0;

    if (this.currentPadlockQuestion) {
      this.currentPadlockQuestion.destroy();
    }

    this._avatarDisplay.play(
      `avatar-walk-${this.sponge.data.save.characterSelect}`
    );
    this.update(0, 0);
    this.paused = true;
    this.pauseScreenVisible = false;
    this.padlockQuestionVisible = false;
    this.currentPadlockQuestion = null;
    this.ended = false;

    this.sounds.music.play();
    this.sounds.musicAlt.play();

    this.countdownDisplay.startCountDown();
  }

  /**
   * preload any assets for this state
   *
   *
   * @memberof EndlessRunnerScene
   */
  preload(): void {
    console.log("EndlessRunnerScene::preload");
    // load any used assets here, we are going to load per scene to improve memory performance.

    super.preload();

    // this.load.image("runner-background", RunnerBackground);
    // this.load.image("runner-lanes", RunnerLanes);
    // this.load.image("runner-line-vertical", GridVertical);
    // this.load.image("runner-line-horizontal", GridHorizontal);
    // this.load.image("collectable", Collectable);
    // this.load.image("avoidable", Avoidable);
    // this.load.image("timer-background", TimerBackground);
    this.load.image("jumpButton", jumpButton);

    switch (this.sponge.data.model.save.characterSelect) {
      case 0:
        break;
    }
    // this.load.spritesheet("avatar", Avatar, {
    //   frameWidth: 200,
    //   frameHeight: 200,
    // });

    this.load.atlas("avatar", AvatarSpriteTexture, AvatarSpriteData);
    // this.load.image("enemy", Enemy);

    this.load.atlas("enemy", EnemySpriteTexture, EnemySpriteData);
    this.load.spritesheet("padlockTexture", padlockTexture, {
      frameWidth: 130,
      frameHeight: 190,
    });
    this.load.spritesheet("pickupTexture", pickupTexture, {
      frameWidth: 130,
      frameHeight: 190,
    });

    //sounds
    this.load.audio("end-game-sound", [EndGameSound, EndGameSoundMP3]);
    this.load.audio("negative-hit-sound", [
      NegativeHitSound,
      NegativeHitSoundMP3,
    ]);
    this.load.audio("negative-flicker-sound", [
      NegativeFlickerHitSound,
      NegativeFlickerHitSoundMP3,
    ]);
    this.load.audio("positive-powerup-sounds", [
      PosativePowerupSound,
      PosativePowerupSoundMP3,
    ]);
    this.load.audio("generic-collection-sound", [
      GenericCollectionSound,
      GenericCollectionSoundMP3,
    ]);
    this.load.audio("generic-collection-alt-sound", [
      GenericCollectionSound2,
      GenericCollectionSound2MP3,
    ]);
    this.load.audio("add-score-sound", [AddScoreSound, AddScoreSoundMP3]);
    this.load.audio("transition-1-sound", [
      TransitionSound,
      TransitionSoundMP3,
    ]);
    this.load.audio("music-sound", [MusicSound, MusicSoundMP3]);
    this.load.audio("music-sound-alt", [MusicSoundAlt, MusicSoundAltMP3]);
    this.load.audio("small-pickup-sound", [
      SmallPickupSound,
      SmallPickupSoundMP3,
    ]);
  }

  wake() {
    console.log("gameWake");
    this.restart();
  }

  /**
   * create any gameObjects that are required here.
   *
   * @memberof EndlessRunnerScene
   */
  create(): void {
    this.events.on("wake", this.wake, this);
    console.log("EndlessRunnerScene::create", this.created);

    if (this.created) {
      this.restart();
      return;
    }

    console.log("first create");

    //TODO: if webgl renederer not avalible.
    this.effects = this.sponge.effects.addMainGamePost(this);

    this.totalQuestionsAsked = 0;
    this.populatePadlockQuestions();

    this.miniGames = shuffleArrayFY([
      "CloudCatcherScene",
      "PasswordRandomiserScene",
      "LockTheDoorScene",
      "TapOutScene",
    ]);
    // when scene is first loaded.

    //Background items.
    this.bg = this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      "runner-atlas",
      "runner-background.png"
    );

    this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      "runner-atlas",
      "runner-lanes.png"
    );

    this.add.image(
      this.cameras.main.centerX,
      this.cameras.main.centerY + 10,
      "runner-atlas",
      "runner-line-vertical.png"
    );

    //horiztonal Lines - create group for this disaply item.
    this.horizontalLines = this.add.group({
      defaultKey: "runner-atlas",
      defaultFrame: "runner-line-horizontal.png",
      maxSize: 20,
      createCallback: (line: Phaser.GameObjects.Sprite) => {
        // if we want to run any functions on the creation of this game object we can here.
        // line.setPipeline(this.bg.pipeline.name);
      },
    });

    //TODO: add initial bars?

    //game structure events (for pause /resume functionallity)
    this.game.events.on("mini-game-complete", this.onMiniGameComplete, this);
    this.game.events.on("mini-game-go-home", this.shutdown, this);
    this.game.events.on("mini-game-restart", this.restart, this);

    //energy bar
    this.energyMeter = new EnergyMeter(this, 75);

    // single pips (points).
    this.anims.create({
      key: "spin",
      frames: this.anims.generateFrameNumbers("pickupTexture", {
        start: 0,
        end: 6,
      }),
      frameRate: 10,
      repeat: -1,
    });

    this.singlePoints = this.physics.add.group({
      defaultKey: "pickupTexture",
      maxSize: 20,
      createCallback: (go: Phaser.GameObjects.Sprite) => {
        go.setSize(80, 40);
        go.setDepth(Depths.COLLECTABLES);
        go.setOrigin(0.5, 1);
        go.play("spin");
      },
    });

    this.anims.create({
      key: "lockspin",
      frames: this.anims.generateFrameNumbers("padlockTexture", {
        start: 0,
        end: 6,
      }),
      frameRate: 10,
      repeat: -1,
    });
    // collectable / avoidable / mini game groups, these are the items that spawn in lanes.
    this.collecatables = this.physics.add.group({
      defaultKey: "padlockTexture",
      maxSize: 20,
      createCallback: (go: Phaser.GameObjects.Sprite) => {
        go.setSize(80, 40);
        go.setDepth(Depths.COLLECTABLES);
        go.setOrigin(0.5, 1);
        go.play("lockspin");
      },
    });

    this.avoidables = this.physics.add.group({
      defaultKey: "runner-atlas",
      defaultFrame: "runner-icon-skull.png",
      maxSize: 20,
      createCallback: (go: Phaser.GameObjects.Sprite) => {
        go.setSize(80, 40);
        go.setDepth(Depths.COLLECTABLES);
        go.setOrigin(0.5, 1);
      },
    });

    //custom animation for the minigame launch (big scary enemies)
    this.anims.create({
      key: "enemy-walk-1",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("enemy", {
        prefix: "Hacker-",
        start: 1,
        end: 14,
        suffix: ".png",
        zeroPad: 0,
      }),
    });
    this.anims.create({
      key: "enemy-walk-3",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("enemy", {
        prefix: "Trojan-",
        start: 1,
        end: 8,
        suffix: ".png",
        zeroPad: 0,
      }),
    });
    this.anims.create({
      key: "enemy-walk-5",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("enemy", {
        prefix: "Clone-Nano-",
        start: 1,
        end: 14,
        suffix: ".png",
        zeroPad: 0,
      }),
    });
    this.anims.create({
      key: "enemy-walk-2",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("enemy", {
        prefix: "Clone-Glitch-",
        start: 1,
        end: 14,
        suffix: ".png",
        zeroPad: 0,
      }),
    });
    this.anims.create({
      key: "enemy-walk-4",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("enemy", {
        prefix: "Clone-Encryptor-",
        start: 1,
        end: 14,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.miniGameLaunchers = this.physics.add.group({
      defaultKey: "enemy",
      maxSize: 5,
      createCallback: (go: Phaser.GameObjects.Sprite) => {
        go.setData("scaleMultiplyer", 2);
        go.setSize(80, 40);
        go.setDepth(Depths.COLLECTABLES);
        go.setOrigin(0.5, 1);
        go.play("enemy-walk-3");
      },
    });

    //avatar
    this.avatar = this.physics.add.sprite(
      this.cameras.main.centerX,
      this.cameras.main.height - 250,
      ""
    );

    this.avatar.setSize(200, 100);
    this.avatar.setVisible(false);

    //we are hiding the original avatar and creating a duplicate as to mirror the visuals in gl pipeline
    this._avatarDisplay = this.add.sprite(
      this.cameras.main.centerX,
      this.cameras.main.height - 400,
      "avatar"
    );
    this._avatarDisplay.setDepth(Depths.AVATAR);
    this._avatarDisplay.setScale(2);

    this.anims.create({
      key: "avatar-walk-0",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Encryptor-",
        start: 1,
        end: 16,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-walk-1",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Glitch-",
        start: 1,
        end: 16,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-walk-2",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Nano-",
        start: 1,
        end: 16,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-stop-0",
      frameRate: 0,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Encryptor-neutral-pose-",
        start: 1,
        end: 1,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-stop-1",
      frameRate: 0,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Glitch-neutral-pose-",
        start: 1,
        end: 1,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-stop-2",
      frameRate: 0,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Nano-neutral-pose-",
        start: 1,
        end: 1,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-jump-0",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Encryptor-full-jump-",
        start: 1,
        end: 30,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-jump-1",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Glitch-full-jump-",
        start: 1,
        end: 30,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this.anims.create({
      key: "avatar-jump-2",
      frameRate: 30,
      repeat: -1,
      frames: this.anims.generateFrameNames("avatar", {
        prefix: "Nano-full-jump-",
        start: 1,
        end: 30,
        suffix: ".png",
        zeroPad: 0,
      }),
    });

    this._avatarDisplay.play(
      `avatar-walk-${this.sponge.data.save.characterSelect}`
    );

    //add our post effects to the avatar display. TODO: if webgl renederer not avalible.
    if (this.effects) this.sponge.effects.addGlitch(this._avatarDisplay);

    //UI
    this.timer = new ScoreTimer(this, 80, 80);
    this.timer.setDepth(Depths.UI);

    this.countdownDisplay = new CountDown(this);
    this.countdownDisplay.on(
      "countdown-complete",
      this.onCountdownComplete,
      this
    );

    this.pauseScreenVisible = false;
    this.padlockQuestionVisible = false;
    this.currentPadlockQuestion = null;
    this.miniGameActive = false;
    this.paused = true;

    this.pauseButton = this.add
      .image(
        this.cameras.main.width + 38,
        80,
        "runner-atlas",
        "hud-fill-right.png"
      )
      .setOrigin(1, 0.5);

    this.pauseButton.setInteractive({ useHandCursor: true });
    this.pauseButton.on("pointerup", () => {
      if (this.pauseScreenVisible || this.miniGameActive) {
        return;
      }

      this.paused = true;
      this.pauseScreenVisible = true;
      this.pauseButton.disableInteractive();

      if (this.countdownDisplay.countdownActive) {
        this.countdownDisplay.pauseCountDown();
      }
      this.showPauseScreen(false);
    });

    this.pauseButton.on("pointerover", () => {
      this.pauseButton.setFrame("hud-fill-right-hover.png");
    });
    this.pauseButton.on("pointerout", () => {
      this.pauseButton.setFrame("hud-fill-right.png");
    });

    this.setupInput();

    //register all physics events.
    this.physics.add.overlap(
      this.avatar,
      this.collecatables,
      this.collectableOverlap,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.avatar,
      this.singlePoints,
      this.collectablePointOverlap,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.avatar,
      this.avoidables,
      this.avoidableOverlap,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.avatar,
      this.miniGameLaunchers,
      this.minigameOverlap,
      undefined,
      this
    );

    //sounds
    this.sounds = {};

    this.sounds.EndGameSound = this.sound.add("end-game-sound", {
      volume: 0.5,
    });
    this.sounds.NegativeHitSound = this.sound.add("negative-hit-sound", {
      volume: 0.5,
    });
    this.sounds.NegativeFlickerHitSound = this.sound.add(
      "negative-flicker-sound",
      {
        volume: 0.3,
      }
    );
    this.sounds.PosativePowerupSound = this.sound.add(
      "positive-powerup-sounds",
      {
        volume: 1,
      }
    );
    this.sounds.GenericCollectionSound = this.sound.add(
      "generic-collection-sound",
      {
        volume: 1,
      }
    );
    this.sounds.GenericCollectionSound2 = this.sound.add(
      "generic-collection-alt-sound",
      {
        volume: 1,
      }
    );
    this.sounds.AddScoreSound = this.sound.add("add-score-sound", {
      volume: 1,
    });
    this.sounds.TransitionSound = this.sound.add("generic-collection-sound", {
      volume: 0.7,
    });

    this.sounds.smallPickup = this.sound.add("small-pickup-sound", {
      volume: 1,
    });

    this.sounds.music = this.sound.add("music-sound", {
      volume: 0.1,
      loop: true,
    }) as Phaser.Sound.WebAudioSound;
    this.sounds.musicAlt = this.sound.add("music-sound-alt", {
      volume: 0,
      loop: true,
    }) as Phaser.Sound.WebAudioSound;

    this.sounds.music.play();
    this.sounds.musicAlt.play();

    this.created = true;
    this.updateDisplayAvatar();
    this.countdownDisplay.startCountDown();
  }

  private setupInput() {
    console.warn("setup input");

    //swipe input on touch
    let downX: number;
    let upX: number;
    let downY: number;
    let upY: number;
    const threshold: number = 50;

    this.input.on(
      "pointerdown",
      function (pointer: any) {
        downX = pointer.x;
        downY = pointer.y;
      },
      this
    );

    this.input.on(
      "pointerup",
      function (pointer: any) {
        upX = pointer.x;
        upY = pointer.y;
        if (upX < downX - threshold) {
          console.log("swipeleft");
          this.events.emit("move-left");
        } else if (upX > downX + threshold) {
          console.log("swiperight");
          this.events.emit("move-right");
        } else if (upY < downY - 100) {
          console.log("swipeup");
          this.avatarJump();
        }
      },
      this
    );

    //listen to any keyboard left / right input
    this.input.keyboard.on("keydown", (keydownEvent: any) => {
      console.log("keydown", keydownEvent);
      if (keydownEvent.key === "ArrowRight") {
        this.events.emit("move-right");
      } else if (keydownEvent.key === "ArrowLeft") {
        this.events.emit("move-left");
      } else if (keydownEvent.key === "ArrowUp") {
        this.events.emit("pressJump");
      } else if (keydownEvent.key === " ") {
        this.events.emit("pressPause");
      }
    });

    //listen to above events and move avatar target position based on inputs
    this.events.on("move-right", () => {
      console.log("-->");
      if (!this.paused && !this.jumpingActive) {
        this.avatarPosition = Math.min(2, this.avatarPosition + 1);
        this.leanIntoItMate(this.effects ? -10 : 10);
      }
    });
    this.events.on("move-left", () => {
      console.log("<--");
      if (!this.paused && !this.jumpingActive) {
        this.avatarPosition = Math.max(0, this.avatarPosition - 1);
        this.leanIntoItMate(this.effects ? 10 : -10);
      }
    });
    this.events.on("pressJump", () => {
      console.log("^^^");
      this.avatarJump();
    });

    this.events.on("pressPause", () => {
      console.log("SPACE");
      if (this.pauseScreenVisible) {
        return;
      }
      if(this.goCountdownActive){
        return;
      }

      this.paused = true;
      this.pauseScreenVisible = true;
      this.pauseButton.disableInteractive();

      this.showPauseScreen(false);
    });
  }

  leanIntoItMate(leanAngle: number) {
    this._avatarDisplay.angle = 0;
    this.add.tween({
      targets: this._avatarDisplay,
      duration: 100,
      ease: "Quad.easeIn",
      angle: leanAngle,
    });
    this.add.tween({
      targets: this._avatarDisplay,
      delay: 200,
      duration: 60,
      ease: "Quad.easeOut",
      angle: 0,
    });
  }

  avatarJump() {
    if (this.jumpingActive) {
      return;
    }
    if (this.paused || this.padlockQuestionVisible) {
      return;
    }

    this.jumpingActive = true;

    this._avatarDisplay.play(
      `avatar-jump-${this.sponge.data.save.characterSelect}`
    );

    this.add.tween({
      targets: this._avatarDisplay,
      duration: 500,
      ease: "Quad.easeOut",
      yoyo: true,
      y: 600,
      onComplete: () => {
        this.jumpingActive = false;
      },
      onCompleteScope: this,
    });
  }

  /**
   * update is called on each frame, when the scene is in an active, non sleep state.
   *
   * @param {number} time time since app launch
   * @param {number} delta miliseconds since update.
   * @memberof EndlessRunnerScene
   */
  update(time: number, delta: number): void {
    super.update(time, delta);

    if (this.paused || this.ended) {
      this._avatarDisplay.play(
        `avatar-stop-${this.sponge.data.save.characterSelect}`
      );
      return; //if paused stop here.
    } else if (
      this._avatarDisplay.anims.getCurrentKey() !==
        `avatar-walk-${this.sponge.data.save.characterSelect}` &&
      !this.jumpingActive
    ) {
      this._avatarDisplay.play(
        `avatar-walk-${this.sponge.data.save.characterSelect}`
      );
    }

    //if game ended then lets slow down, if not speed up
    if (this.ended) {
      this.gameSpeed = Math.max(this.gameSpeed - 0.0001 * delta, 0);
    } else {
      this.gameSpeed += 0.0000001 * delta;
    }

    //update our distance / progress varibles
    this.currentDistance += delta * this.gameSpeed;
    this.lastLineDistance += delta * this.gameSpeed;
    this.lastCollectableDistance += delta * this.gameSpeed;
    this.lastPointDistance += delta * this.gameSpeed;

    this.updateDisplay(time, delta);
    this.updateDisplayAvatar();

    //ignore any timer / gameplay interaction from here as game has ended
    if (this.ended) {
      return;
    }

    //update timer
    // this.timer.value = this.currentDistance;
    this.timer.update();

    //update interactions like collectables / enemys
    this.updateInteraction(time, delta);
  }

  /**
   * updates display items, cull items off screen and project those that are.
   *
   * @param {number} time
   * @param {number} delta
   * @memberof EndlessRunnerScene
   */
  updateDisplay(time: number, delta: number): void {
    //update our horizontal bars
    this.progressBackgroundLines(delta, this.gameSpeed);

    //update our collectables
    this.singlePoints.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        this.projectAndCull(
          gameObject,
          this.singlePoints,
          delta,
          this.gameSpeed
        );
      }
    );
    //update our collectables
    this.collecatables.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        this.projectAndCull(
          gameObject,
          this.collecatables,
          delta,
          this.gameSpeed
        );
      }
    );

    //update our avoidable
    this.avoidables.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        this.projectAndCull(gameObject, this.avoidables, delta, this.gameSpeed);
      }
    );

    //update our mini game launchers
    this.miniGameLaunchers.children.iterate(
      (gameObject: Phaser.GameObjects.Sprite) => {
        this.projectAndCull(
          gameObject,
          this.miniGameLaunchers,
          delta,
          this.gameSpeed
        );
      }
    );
  }

  /**
   * create new game interactions based on distance.
   *
   * @private
   * @param {number} time
   * @param {number} delta
   * @memberof EndlessRunnerScene
   */
  private updateInteraction(time: number, delta: number) {
    //add new line after traveling 7 unit
    if (this.lastLineDistance > 7) {
      this.lastLineDistance -= 7;
      const newBar = this.horizontalLines.get(this.cameras.main.centerX, 0);
      if (newBar) {
        newBar.setActive(true).setVisible(true);
        newBar.setData("distance", 100);
        this.projectLine(newBar);
      }

      //flipping avatar makes it look like hes running
      // this.avatar.flipX = !this.avatar.flipX;
    }

    const randomLanes = shuffleArrayFY([0, 1, 2]);

    //spawn more collectables after X units
    if (this.lastCollectableDistance > 60) {
      this.lastCollectableDistance -= 60;

      //collectable
      this.lastEnergyCount++;
      if (this.lastEnergyCount > 3) {
        this.createCollectableAtLane(randomLanes.pop());
        this.lastEnergyCount = 0;
      }

      //avoidable
      this.createAvoidableAtLane(randomLanes.pop());

      const doubleBad: boolean =
        Phaser.Math.RND.between(1, 20) > 13 ? true : false;

      if (doubleBad) {
        //create second baddie to jump
        this.createAvoidableAtLane(randomLanes.pop());
      } else {
        //mini game
        this.lastMiniGameCount++;
        if (this.lastMiniGameCount > 6) {
          this.createMiniGameAvoidableAtLane(randomLanes.pop());
          this.lastMiniGameCount -= 6;
        }
      }
    }

    if (this.lastPointDistance > 10 && randomLanes.length > 0) {
      this.lastPointDistance -= 10;

      //avoidable
      this.createPointAtLane(randomLanes.pop());
    }

    //update avatar postion
    const targetPosition = lanePositions[this.avatarPosition];

    this.add.tween({
      targets: this.avatar,
      duration: 200,
      ease: "Back.easeOut",
      x: targetPosition,
    });

    //slowly decrease energy bar, this returns true if it drops below 0
    const complete = this.energyMeter.decrease(delta * 0.005);

    //if no energy end game.
    if (complete) {
      this.endGame();
    }
  }

  /**
   * when a posative thing happens (Collect energy)
   *
   * @private
   * @memberof EndlessRunnerScene
   */
  private positiveFeedback() {
    if (this.effects) {
      (this.cameras.main.pipeline as PostPipeline).fire(this, 700, 0.4);
    }

    this.sounds.PosativePowerupSound.play({
      volume: 0.2,
    });
  }

  /**
   * when bad things happen
   *
   * @private
   * @memberof EndlessRunnerScene
   */
  private negativeFeedback() {
    if (this.effects) {
      (this._avatarDisplay.pipeline as PostPipeline).fire(this, 300);
    }

    this.cameras.main.shake(300, 0.001);

    this.sounds.NegativeHitSound.play({
      volume: 0.4,
    });
    this.sounds.NegativeFlickerHitSound.play({ volume: 0.6 });
  }

  /**
   * mirror our avatar display item to that of the physics engine.
   *
   * @memberof EndlessRunnerScene
   */
  updateDisplayAvatar() {
    this._avatarDisplay.x = this.avatar.x;

    if (this.effects) {
      this._avatarDisplay.scaleY = this.avatar.scaleY * -2;
      this._avatarDisplay.flipX = this.avatar.flipX;

      if (!this.jumpingActive) {
        this._avatarDisplay.y = this.cameras.main.height - this.avatar.y;
      }
    } else {
      this._avatarDisplay.scaleY = this.avatar.scaleY * 2;
      this._avatarDisplay.flipX = this.avatar.flipX;

      if (!this.jumpingActive) {
        this._avatarDisplay.y = this.avatar.y;
      }
    }
  }

  populatePadlockQuestions() {
    console.warn(
      "qBank population start, questions asked so far:",
      this.totalQuestionsAsked
    );
    //initialise qBank
    this.currentQuestions = [];

    if (this.totalQuestionsAsked < 3) {
      this.pushInQuestions(this.sponge.data.content.mainQuestionsEasy);
    } else if (this.totalQuestionsAsked >= 5 && this.totalQuestionsAsked < 10) {
      this.pushInQuestions(this.sponge.data.content.mainQuestionsMedium);
    } else if (
      this.totalQuestionsAsked >= 10 &&
      this.totalQuestionsAsked < 20
    ) {
      this.pushInQuestions(this.sponge.data.content.mainQuestionsHard);
    } else if (this.totalQuestionsAsked >= 20) {
      this.pushInQuestions(this.sponge.data.content.mainQuestionsEasy);
      this.pushInQuestions(this.sponge.data.content.mainQuestionsMedium);
      this.pushInQuestions(this.sponge.data.content.mainQuestionsHard);
    }

    shuffleArrayFY(this.currentQuestions);

    console.warn(
      "qBank population completed",
      this.currentQuestions,
      this.totalQuestionsAsked
    );
  }

  pushInQuestions(inArray: QuestionModel[]) {
    for (let i: number = 0; i < inArray.length; i++) {
      this.currentQuestions.push(inArray[i]);
    }
  }

  /**
   * overlaps Avatar with a collectable
   *
   * @private
   * @param {Phaser.GameObjects.Sprite} avatar
   * @param {Phaser.GameObjects.Sprite} go
   * @memberof EndlessRunnerScene
   */
  private collectableOverlap(
    avatar: Phaser.GameObjects.Sprite,
    go: Phaser.GameObjects.Sprite
  ) {
    if (this.ended) {
      return;
    }

    if (go.active && !this.jumpingActive) {
      go.setActive(false).setVisible(false);

      console.warn(
        "qBank length before question picked",
        this.currentQuestions.length
      );

      //get question to ask.
      const question: QuestionModel = this.currentQuestions.shift();

      if (question === undefined) {
        this.positiveFeedback();
        this.energyMeter.increase(5);
        return;
      }

      this.totalQuestionsAsked++;

      console.warn("Total Questions Asked:", this.totalQuestionsAsked);

      // if no questions left in current question bank, regenerate based on question Count
      console.warn(
        "qBank length after question picked",
        this.currentQuestions.length
      );
      if (this.currentQuestions.length < 2) {
        this.populatePadlockQuestions();
      }

      this.paused = true;
      this.padlockQuestionVisible = true;

      this.currentPadlockQuestion = new FullScreenQuestionComponent(
        this,
        question,
        (correct: boolean) => {
          if (correct) {
            this.energyMeter.increase(25);
            this.positiveFeedback();
          } else {
            this.energyMeter.decrease(10);
            this.negativeFeedback();
          }

          this.padlockQuestionVisible = false;
          this.currentPadlockQuestion = null;

          const go = this.add
            .text(
              this.cameras.main.centerX,
              this.cameras.main.centerY,
              this.sponge.data.model.content.strings.go,
              this.sponge.data.model.fonts.countdown
            )
            .setOrigin(0.5)
            .setStroke("#30aee4", 20);

            this.goCountdownActive = true;

          this.tweens.add({
            targets: go,
            duration: 1000,
            alpha: 0,
            onComplete: () => {
              this.onCountdownComplete();
              go.destroy();
            },
            onCompleteScope: this,
          });
        }
      ).setDepth(Depths.UI);

      // this.energyMeter.increase(5);
      // this.positiveFeedback();
    }
  }
  private collectablePointOverlap(
    avatar: Phaser.GameObjects.Sprite,
    go: Phaser.GameObjects.Sprite
  ) {
    if (this.ended) {
      return;
    }

    if (go.active && !this.jumpingActive) {
      go.setActive(false).setVisible(false);
      this.timer.value++;
      this.energyMeter.increase(0.5);
      this.sounds.smallPickup.play();
    }
  }

  /**
   *overlaps Avatar with a avoidable
   *
   * @private
   * @param {Phaser.GameObjects.Sprite} avatar
   * @param {Phaser.GameObjects.Sprite} go
   * @memberof EndlessRunnerScene
   */
  private avoidableOverlap(
    avatar: Phaser.GameObjects.Sprite,
    go: Phaser.GameObjects.Sprite
  ) {
    if (this.ended) {
      return;
    }

    if (go.active && !this.jumpingActive) {
      go.setActive(false).setVisible(false);
      this.energyMeter.decrease(10);
      this.negativeFeedback();
    }
  }

  /**
   *  overlaps Avatar with a minigame boss
   *
   * @private
   * @param {Phaser.GameObjects.Sprite} avatar
   * @param {Phaser.GameObjects.Sprite} go
   * @memberof EndlessRunnerScene
   */
  private minigameOverlap(
    avatar: Phaser.GameObjects.Sprite,
    go: Phaser.GameObjects.Sprite
  ) {
    if (this.ended) {
      return;
    }

    if (go.active) {
      go.setActive(false).setVisible(false);
      this.negativeFeedback();

      const miniGame: string = go.data.values.miniGame; // getData("miniGame");
      const enemyType: number = go.data.values.enemyType; //getData("enemyType");
      console.log("hit enemy: ", enemyType);
      this.launchMiniGame(miniGame, enemyType);
      this.miniGameActive = true;
    }
  }

  /**
   * checks if a gameObject in camera view, projects or destroys it
   *
   * @private
   * @param {Phaser.GameObjects.Sprite} gameObject
   * @param {Phaser.GameObjects.Group} group
   * @param {number} delta
   * @param {number} SPEED
   * @memberof EndlessRunnerScene
   */
  private projectAndCull(
    gameObject: Phaser.GameObjects.Sprite,
    group: Phaser.GameObjects.Group,
    delta: number,
    SPEED: number
  ) {
    if (gameObject.y > this.cameras.main.height + gameObject.height) {
      group.killAndHide(gameObject);
    } else {
      const d = gameObject.getData("distance");
      gameObject.setData("distance", d - delta * SPEED);

      if (gameObject.getData("switchState") < 2 && d < 20) {
        gameObject.setData("switchState", 2);
        const currentLane = gameObject.getData("lane");

        // array of all lanes, filter out current, shuffle and then return the first element,
        // this gives us a random lane that's not the current.

        // const targetLane = shuffleArrayFY(
        //   [0, 1, 2].filter((lane) => lane !== currentLane)
        // )[0];

        // move one lane nearer
        let targetLane: number = currentLane;
        console.log(this.avatarPosition, currentLane);
        if (this.avatarPosition > currentLane) {
          targetLane += 1;
        } else if (this.avatarPosition < currentLane) {
          targetLane -= 1;
        }

        console.log(">>>>>targetLane<<<<<", targetLane);
        // gameObject.setData("lane", targetLane); //TODO: animate / randomise switching lanes.
        this.add.tween({
          targets: gameObject.data.values,
          lane: targetLane,
          duration: 200,
        });
      }

      this.projectCollectable(gameObject);
    }
  }

  /**
   *
   *
   * @private
   * @param {number} delta
   * @param {number} SPEED
   * @memberof EndlessRunnerScene
   */
  private progressBackgroundLines(delta: number, SPEED: number) {
    this.horizontalLines.children.iterate((bar: Phaser.GameObjects.Sprite) => {
      if (bar.y > this.cameras.main.height + bar.height) {
        this.horizontalLines.killAndHide(bar);
      } else {
        const d = bar.getData("distance");
        bar.setData("distance", d - delta * SPEED);
        this.projectLine(bar);
      }
    });
  }

  /**
   * create point item
   *
   * @private
   * @param {*} lane
   * @memberof EndlessRunnerScene
   */
  private createPointAtLane(lane: any) {
    const newCollectable = this.singlePoints.get(this.cameras.main.centerX, 0);
    if (newCollectable) {
      newCollectable.setActive(true).setVisible(true);
      newCollectable.setData("distance", 100);
      newCollectable.setData("lane", lane as Lane);
      this.projectCollectable(newCollectable);
    }
  }
  /**
   * create good item
   *
   * @private
   * @param {*} lane
   * @memberof EndlessRunnerScene
   */
  private createCollectableAtLane(lane: any) {
    const newCollectable = this.collecatables.get(this.cameras.main.centerX, 0);
    if (newCollectable) {
      newCollectable.setActive(true).setVisible(true);
      newCollectable.setData("distance", 100);
      newCollectable.setData("lane", lane as Lane);
      this.projectCollectable(newCollectable);
    }
  }

  /**
   * create bad item
   *
   * @private
   * @param {*} badLane
   * @memberof EndlessRunnerScene
   */
  private createAvoidableAtLane(badLane: any) {
    const newAvoidable = this.avoidables.get(this.cameras.main.centerX, 0);

    if (newAvoidable) {
      newAvoidable.setActive(true).setVisible(true);
      newAvoidable.setData("distance", 100);
      newAvoidable.setData("lane", badLane as Lane);

      this.projectCollectable(newAvoidable);
    }
  }

  /**
   * create mini game boss
   *
   * @private
   * @param {*} badLane
   * @memberof EndlessRunnerScene
   */
  private createMiniGameAvoidableAtLane(badLane: any) {
    const newMiniGameAvoidable: Phaser.Physics.Arcade.Sprite = this.miniGameLaunchers.get(
      this.cameras.main.centerX,
      0
    );
    if (newMiniGameAvoidable) {
      const key = this.miniGames[
        this.currentMiniGameCount % this.miniGames.length
      ];

      console.log("launchMiniGame", key);

      const enemyType: number = 1 + (this.currentMiniGameCount % 5);

      newMiniGameAvoidable.play("enemy-walk-" + enemyType);

      this.currentMiniGameCount++;

      newMiniGameAvoidable.setActive(true).setVisible(true);
      newMiniGameAvoidable.setData("distance", 100);
      newMiniGameAvoidable.setData("lane", badLane as Lane);
      newMiniGameAvoidable.setData(
        "switchState",
        Phaser.Math.RND.integerInRange(0, 1)
      );
      newMiniGameAvoidable.setData("miniGame", key);
      newMiniGameAvoidable.setData("enemyType", enemyType);

      this.projectCollectable(newMiniGameAvoidable);
    }
  }

  /**
   * some psedo - 3d maths, to give the idea of perspective (horizontal line)
   *
   * @param {Phaser.GameObjects.Sprite} go
   * @memberof EndlessRunnerScene
   */
  projectLine(go: Phaser.GameObjects.Sprite): void {
    const minY: number = 435;
    const maxY: number = 1280;

    const distance: number = go.getData("distance");

    const easedValue = Phaser.Math.Easing.Cubic.Out(distance / 100);

    go.y = minY + (maxY - minY) * ((100 - easedValue * 100) / 100);

    go.scaleY = Math.max(0.1, 1 - easedValue);
  }

  /**
   * some psedo - 3d maths, to give the idea of perspective (any lane objects)
   *
   * @param {Phaser.GameObjects.Sprite} go
   * @memberof EndlessRunnerScene
   */
  projectCollectable(go: Phaser.GameObjects.Sprite): void {
    const minY: number = 435;
    const maxY: number = 1280;

    const distance: number = go.getData("distance");
    const lane: Lane = go.getData("lane");

    const easedValue = Phaser.Math.Easing.Cubic.Out(distance / 100);

    go.y = minY + (maxY - minY) * ((100 - easedValue * 100) / 100);

    const easedLinear = 1 - Phaser.Math.Easing.Linear(distance / 100);

    const scaleMultipler = go.getData("scaleMultiplyer") || 1;

    // go.x =
    //   lanePositionsStart[lane] +
    //   (lanePositionsEnd[lane] - lanePositionsStart[lane]) *
    //     ((100 - easedValue * 100) / 100);

    const farPosition =
      (lane / 2) *
        (lanePositionsStartBounds.max - lanePositionsStartBounds.min) +
      lanePositionsStartBounds.min;

    const closePosition =
      (lane / 2) * (lanePositionsEndBounds.max - lanePositionsEndBounds.min) +
      lanePositionsEndBounds.min;

    go.x = closePosition + easedValue * (farPosition - closePosition);

    go.scaleY = go.scaleX = Math.max(easedLinear) * scaleMultipler;

    go.alpha = Math.min(1, easedLinear * 5);
  }

  /**
   * triggers to end of a run, launches results component, removes lane items and decellerates user.
   *
   * @memberof EndlessRunnerScene
   */
  endGame(): void {
    //out of energy
    if (!this.ended) {
      console.log("EndlessRunnerScene::endGame");

      this._avatarDisplay.play(
        `avatar-stop-${this.sponge.data.save.characterSelect}`
      );

      this.sounds.EndGameSound.play({
        volume: 0.2,
      });

      this.ended = true;
      this.paused = true;

      this.singlePoints.children.iterate(
        (gameObject: Phaser.GameObjects.Sprite) => {
          gameObject.setActive(false).setVisible(false);
        }
      );
      this.miniGameLaunchers.children.iterate(
        (gameObject: Phaser.GameObjects.Sprite) => {
          gameObject.setActive(false).setVisible(false);
        }
      );

      this.avoidables.children.iterate(
        (gameObject: Phaser.GameObjects.Sprite) => {
          gameObject.setActive(false).setVisible(false);
        }
      );
      this.collecatables.children.iterate(
        (gameObject: Phaser.GameObjects.Sprite) => {
          gameObject.setActive(false).setVisible(false);
        }
      );

      this.time.delayedCall(
        1000,
        () => {
          // if(this.sponge)

          this.sounds.AddScoreSound.play({
            volume: 0.3,
          });

          console.log(this);

          // this.results = new ResultsComponent(
          //   this,
          //   Math.floor(this.timer.value),
          //   () => {
          //     this.restart();
          //   },
          //   () => {
          //     this.shutdown();
          //   }
          // );

          // UNCOMMENT FOR RELEASE
          this.showPauseScreen(true);

          // this.results.setDepth(Depths.UI);
        },
        [],
        this
      );
    }
  }

  showPauseScreen(endGame: boolean) {
    const ps = endGame
      ? new PauseScreen(this, "pause-instructions", this.timer.value, true)
      : new PauseScreen(this, "pause-instructions");
    ps.on("closeAndGoHome", this.shutdown, this);
    ps.on("restartPressed", this.restart, this);
    ps.on("resumePressed", this.resumePausedGame, this);
    this.children.bringToTop(ps);
  }

  resumePausedGame() {
    if (!this.padlockQuestionVisible) {
      // added to prevent start mid countdown
      if (this.countdownDisplay.countdownPaused) {
        this.countdownDisplay.resumeCountDown();
      } else {
        this.onCountdownComplete();
      }
    } else {
      this.pauseScreenVisible = false;
      this.pauseButton.setInteractive();
    }
  }

  /**
   * when a mini game is marked as component
   *
   * @param {string} key
   * @param {number} score 0 - fail, 1-pass
   * @memberof EndlessRunnerScene
   */
  onMiniGameComplete(key: string, score: number) {
    console.log("EndlessRunnerScene::minigameCOmplete", key, score);
    this.sounds.TransitionSound.play();

    //decrease energy by 10 times score
    score < 1 ? this.energyMeter.decrease(20) : this.energyMeter.increase(10);

    //show pauseButton
    this.pauseButton.setActive(true).setVisible(true);

    this.countdownDisplay.startCountDown();

    // this.time.delayedCall(500, () => {
    //   this.events.emit("countdown-complete");
    // });

    this.sounds.music.volume = 0.1;
    this.sounds.musicAlt.volume = 0;
    this.sounds.music.play();
    this.sounds.musicAlt.play();
    this.miniGameActive = false;
  }

  onCountdownComplete() {
    //add countdown to resume game?
    this.paused = false;
    this.pauseScreenVisible = false;
    this.pauseButton.setActive(true).setVisible(true).setInteractive();

    this.goCountdownActive = false;

    //   const key = this.miniGames[
    //     this.currentMiniGameCount % this.miniGames.length
    //   ];
    //   const enemyType: number = 1 + (this.currentMiniGameCount % 5);

    // this.launchMiniGame(key, enemyType);
  }

  /**
   * launch a random minigame that are looped based on launch order.
   *
   * @memberof EndlessRunnerScene
   */
  launchMiniGame(key: string, enemyType: number) {
    this.sounds.TransitionSound.play();

    this.sounds.music.volume = 0;
    this.sounds.musicAlt.volume = 0.1;

    this.paused = true;

    let popupKey: string;
    switch (enemyType) {
      case 1:
        popupKey = "enemy-hacker";
        break;
      case 2:
        popupKey = "enemy-clone-g";
        break;
      case 3:
        popupKey = "enemy-trojan";
        break;
      case 4:
        popupKey = "enemy-clone-e";
        break;
      default:
        popupKey = "enemy-clone-n";
        break;
    }

    if (this.sponge.data.save.seenInstructions.indexOf(popupKey) === -1) {
      this.sponge.data.save.seenInstructions.push(popupKey);

      this.sponge.html.launchPopup(popupKey, () => {
        this.launchMingameOnPopupClose(key);
      });
    } else {
      this.launchMingameOnPopupClose(key);
    }
  }

  launchMingameOnPopupClose(key: string) {
    //hide this scenes pauseButton
    this.pauseButton.setActive(false).setVisible(false).disableInteractive();
    this.scene.launch(key);
  }

  /**
   * destroy and remove this scene from memory.
   *
   * @memberof EndlessRunnerScene
   */
  shutdown(): void {
    console.log("EndlessRunnerScene::shutdown");

    if (this.sounds.music) {
      this.sounds.musicAlt.stop();
      this.sounds.music.stop();
    }

    this.timer.reset();

    // drop references to anything we have in create

    // try {
    // this.somthing.destroy();
    // this.somthing = undefined;
    // } catch (e) {
    //   console.warn("error trying to destroy somthing", e);
    // }

    // finally shutdown our state

    this.scene.switch("SplashScene");

    super.shutdown();
  }
}
